import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getDbsCouponTickets = async () => {
  try {
    const resp = await apiWrapper(
      "GET",
      "dbs/tickets",
      {},
      false,
      null,
      "Migrated"
    );
    store.commit("dbs/setMyCouponTickets", resp.data);
  } catch (err) {
    console.log('ERROR"" getDbsCouponTickets()');
    throw err;
  }
};
